/**
 * <faq-occasion-filter>
 *
 * Loaded by sections/cc-faq-section.liquid on every instance sitewide.
 * Listens for `gift-guide:occasion-change` (dispatched on `document` by
 * <occasion-selector>, see gift-guide-occasions.js) and shows/hides its
 * own <li data-occasion="..."> entries to match. Entries with no
 * `data-occasion` value are the general/fallback set, shown whenever the
 * active occasion has no FAQs tagged to it specifically.
 *
 * A no-op on every FAQ instance that isn't on a page with an occasion
 * selector: nothing dispatches the event, so the server-rendered list
 * (all items visible) never changes.
 */
if (!customElements.get('faq-occasion-filter')) {
  customElements.define(
    'faq-occasion-filter',
    class FaqOccasionFilter extends HTMLElement {
      constructor() {
        super();
        this.items = Array.from(this.querySelectorAll('[data-occasion]'));
        this.onOccasionChange = this.onOccasionChange.bind(this);
      }

      connectedCallback() {
        document.addEventListener('gift-guide:occasion-change', this.onOccasionChange);
      }

      disconnectedCallback() {
        document.removeEventListener('gift-guide:occasion-change', this.onOccasionChange);
      }

      onOccasionChange(event) {
        const handle = event.detail && event.detail.handle;
        if (!handle) return;
        this.filter(handle);
      }

      filter(handle) {
        // General (untagged) questions always show, regardless of which
        // occasion is active - they're not occasion-specific. An
        // occasion-tagged question shows ADDITIONALLY, only while its own
        // occasion is active. Previously the general set was hidden
        // entirely as soon as ANY tagged match existed, so with only one
        // occasion built out so far (birthday), every other question
        // disappeared down to that single item.
        this.items.forEach((item) => {
          const isGeneral = item.dataset.occasion === '';
          const shouldShow = isGeneral || item.dataset.occasion === handle;
          item.hidden = !shouldShow;
        });
      }
    }
  );
}
